import { render } from "./OnStartModal.vue?vue&type=template&id=3850d53e"
import script from "./OnStartModal.vue?vue&type=script&lang=js"
export * from "./OnStartModal.vue?vue&type=script&lang=js"

import "./OnStartModal.vue?vue&type=style&index=0&id=3850d53e&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__